export default "__VITE_PUBLIC_ASSET__2fa7b576__"